import React, { useEffect, useState } from "react";
import { Rocket } from "lucide-react";
import { api } from "../lib/api";
import { Loader, EmptyState } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";

export default function MyPromotions() {
  const [items, setItems] = useState(null);
  useEffect(() => { api("/promotions/mine").then(setItems).catch(() => setItems([])); }, []);
  if (!items) return <Loader />;
  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <PageHeader title="إعلاناتي المموَّلة" />
      {items.length === 0 ? <EmptyState icon={Rocket} title="لا توجد إعلانات ممولة بعد" /> : (
        <div className="space-y-3">
          {items.map((p) => {
            const active = p.status === "active" && new Date(p.expires_at) > new Date();
            const pct = p.target_impressions ? Math.min(100, Math.round((p.current_impressions / p.target_impressions) * 100)) : 0;
            return (
              <div key={p.promotion_id || p.product_id} className="bg-white rounded-2xl border border-[#E8EAF2] p-4">
                <div className="flex items-center justify-between">
                  <p className="font-black text-[#161629]">{p.product_name || p.product_id}</p>
                  <span className={`text-xs font-black px-2 py-1 rounded-lg ${active ? "bg-[#D9F8E8] text-[#00D26A]" : "bg-[#F0F2FA] text-[#6B7280]"}`}>{active ? "نشط" : "منتهي"}</span>
                </div>
                <div className="flex gap-2 mt-3">
                  <div className="flex-1 bg-[#F7F8FE] rounded-xl p-2.5 text-center">
                    <p className="text-lg font-black text-[#161629]" data-testid={`promo-impressions-${p.product_id}`}>{p.current_impressions || 0}</p>
                    <p className="text-[11px] text-[#6B7280]">مرات الظهور</p>
                  </div>
                  <div className="flex-1 bg-[#F7F8FE] rounded-xl p-2.5 text-center">
                    <p className="text-lg font-black text-[#161629]" data-testid={`promo-clicks-${p.product_id}`}>{p.clicks || 0}</p>
                    <p className="text-[11px] text-[#6B7280]">النقرات على المنتج</p>
                  </div>
                </div>
                {p.target_impressions ? (
                  <>
                    <div className="w-full h-2 bg-[#F0F2FA] rounded-full mt-3 overflow-hidden"><div className="h-full bg-[#FF3D5A]" style={{ width: `${pct}%` }} /></div>
                    <p className="text-xs text-[#6B7280] mt-1">{p.current_impressions || 0} / {p.target_impressions} ظهور</p>
                  </>
                ) : null}
                {p.expires_at && <p className="text-xs text-[#6B7280] mt-1">ينتهي: {new Date(p.expires_at).toLocaleDateString("ar")}</p>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
